import React from "react"

import Ad from "./Ad"
import CallCenter from "./CallCenter"
import Product from "./Product"

function Footer() {
  return (
    <>
      <article className="botB">
        <Ad />
        <CallCenter />
      </article>
      <Product />
    </>
  )
}

export default Footer
